function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Rectangle 2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "mobile-qr-code",
  transform: "translate(14.000000, 8.000000)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-2",
  transform: "translate(-1.000000, -1.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.70322581,7.89806452 L6.79096774,7.89806452 C7.49646697,7.89806452 8.0683871,7.32614439 8.0683871,6.62064516 L8.0683871,2.53290323 C8.0683871,1.827404 7.49646697,1.25548387 6.79096774,1.25548387 L2.70322581,1.25548387 C1.99772658,1.25548387 1.42580645,1.827404 1.42580645,2.53290323 L1.42580645,6.62064516 C1.42580645,7.32614439 1.99772658,7.89806452 2.70322581,7.89806452 Z M3.98064516,3.81032258 L5.51354839,3.81032258 L5.51354839,5.34322581 L3.98064516,5.34322581 L3.98064516,3.81032258 Z",
  id: "Shape",
  fill: "#696969",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.79096774,15.5625806 L2.70322581,15.5625806 C1.99772658,15.5625806 1.42580645,16.1345008 1.42580645,16.84 L1.42580645,20.9277419 C1.42580645,21.6332412 1.99772658,22.2051613 2.70322581,22.2051613 L6.79096774,22.2051613 C7.49646697,22.2051613 8.0683871,21.6332412 8.0683871,20.9277419 L8.0683871,16.84 C8.0683871,16.5012073 7.93380223,16.1762907 7.69423963,15.9367281 C7.45467703,15.6971655 7.12976042,15.5625806 6.79096774,15.5625806 Z M5.51354839,19.6503226 L3.98064516,19.6503226 L3.98064516,18.1174194 L5.51354839,18.1174194 L5.51354839,19.6503226 Z",
  id: "Shape",
  fill: "#696969",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.0980645,1.25548387 L17.0103226,1.25548387 C16.3048234,1.25548387 15.7329032,1.827404 15.7329032,2.53290323 L15.7329032,6.62064516 C15.7329032,7.32614439 16.3048234,7.89806452 17.0103226,7.89806452 L21.0980645,7.89806452 C21.8035637,7.89806452 22.3754839,7.32614439 22.3754839,6.62064516 L22.3754839,2.53290323 C22.3754839,1.827404 21.8035637,1.25548387 21.0980645,1.25548387 Z M19.8206452,5.34322581 L18.2877419,5.34322581 L18.2877419,3.81032258 L19.8206452,3.81032258 L19.8206452,5.34322581 Z",
  id: "Shape",
  fill: "#696969",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8787097,11.4748387 L2.70322581,11.4748387 C1.99772658,11.4748387 1.42580645,12.0467588 1.42580645,12.7522581 C1.42580645,13.4577573 1.99772658,14.0296774 2.70322581,14.0296774 L9.60129032,14.0296774 L9.60129032,14.796129 C9.60129032,15.5016283 10.1732104,16.0735484 10.8787097,16.0735484 C11.5842089,16.0735484 12.156129,15.5016283 12.156129,14.796129 L12.156129,12.7522581 C12.156129,12.4134654 12.0215442,12.0885488 11.7819816,11.8489862 C11.542419,11.6094236 11.2175024,11.4748387 10.8787097,11.4748387 L10.8787097,11.4748387 Z",
  id: "Path",
  fill: "#696969",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.0980645,13.5187097 L19.0541935,13.5187097 C18.3486943,13.5187097 17.7767742,14.0906298 17.7767742,14.796129 C17.7767742,15.5016283 18.3486943,16.0735484 19.0541935,16.0735484 L19.8206452,16.0735484 L19.8206452,19.6503226 L16.243871,19.6503226 L16.243871,14.796129 C16.243871,14.0906298 15.6719508,13.5187097 14.9664516,13.5187097 C14.2609524,13.5187097 13.6890323,14.0906298 13.6890323,14.796129 L13.6890323,20.9277419 C13.6890323,21.6332412 14.2609524,22.2051613 14.9664516,22.2051613 L21.0980645,22.2051613 C21.8035637,22.2051613 22.3754839,21.6332412 22.3754839,20.9277419 L22.3754839,14.796129 C22.3754839,14.0906298 21.8035637,13.5187097 21.0980645,13.5187097 L21.0980645,13.5187097 Z",
  id: "Path",
  fill: "#696969",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8787097,17.6064516 C10.1732104,17.6064516 9.60129032,18.1783717 9.60129032,18.883871 L9.60129032,20.9277419 C9.60129032,21.6332412 10.1732104,22.2051613 10.8787097,22.2051613 C11.5842089,22.2051613 12.156129,21.6332412 12.156129,20.9277419 L12.156129,18.883871 C12.156129,18.5450783 12.0215442,18.2201617 11.7819816,17.9805991 C11.542419,17.7410365 11.2175024,17.6064516 10.8787097,17.6064516 L10.8787097,17.6064516 Z",
  id: "Path",
  fill: "#696969",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2,8.66451613 C14.2,7.9590169 13.6280799,7.38709677 12.9225806,7.38709677 L12.156129,7.38709677 L12.156129,2.53290323 C12.156129,1.827404 11.5842089,1.25548387 10.8787097,1.25548387 C10.1732104,1.25548387 9.60129032,1.827404 9.60129032,2.53290323 L9.60129032,8.66451613 C9.60129032,9.37001536 10.1732104,9.94193548 10.8787097,9.94193548 L12.9225806,9.94193548 C13.6280799,9.94193548 14.2,9.37001536 14.2,8.66451613 Z",
  id: "Path",
  fill: "#696969",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.0980645,9.43096774 L17.0103226,9.43096774 C16.3048234,9.43096774 15.7329032,10.0028879 15.7329032,10.7083871 C15.7329032,11.4138863 16.3048234,11.9858065 17.0103226,11.9858065 L21.0980645,11.9858065 C21.8035637,11.9858065 22.3754839,11.4138863 22.3754839,10.7083871 C22.3754839,10.0028879 21.8035637,9.43096774 21.0980645,9.43096774 Z",
  id: "Path",
  fill: "#696969",
  fillRule: "nonzero"
})));

var SvgQrIcon2 = function SvgQrIcon2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQrIcon2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/QRIcon2.8d06a242.svg";
export { ForwardRef as ReactComponent };